import { StyledMaxWidth } from './styled';

export const MaxWidth = StyledMaxWidth;
